export const isProd: boolean = process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === 'gray';

export enum TENANT_ENV {
    JDDJ = "JDDJ", // 京东到家/到家小店/同城到家
    ZGB = "ZGB", // 掌柜宝/京东京喜/京东零售
    TCG = "TCG", // 同城购/同城到店
    JDQC = "JDQC", // 京东汽车
    SX = "SX", // 商选
    JSJ = "JSJ", // 京东酒世界
    MY = "MY", // 母婴
    QZC = "QZC", // 前置仓
    JDJD = "JDJD", //京东家电
    JDZMD = "JDZMD", //京东家电专卖店
}

/**
 * 菜单code
 */
export const MAP_SASS_MENU_CODE = {
    workerCenter: "24240140000158460", //
    permission: "21347100000721336", // 权限管理
    peopleManagement: "21347100001342369", // 人员管理
    attendanceManagement: "21347100001697197", // 人员考勤管理
    performanceManagement: "21347100001926350", // 地勤考核系统
    ifame: "22250210000179039", // 线索管理
    customer: "22250210000299707", // 客户管理
    smart: "21347100000858981", // 拜访管理
};

/**
 * 一级租户code
 *
 * 线上&灰度，预发分开
 */
export const MAP_TENANT_FIRST_CODE: any = {
    [TENANT_ENV.JDDJ]: isProd ? "20220926001019" : "20220609000002",
    [TENANT_ENV.ZGB]: isProd ? "20210914000046" : "20210909000007",
    [TENANT_ENV.TCG]: isProd ? "20220614000571" : "20220613000005",
    [TENANT_ENV.JDQC]: isProd ? "20221017000801" : "20220218000008",
    [TENANT_ENV.JSJ]: isProd ? "20211210000026" : "20211209000016",
    [TENANT_ENV.MY]: isProd ? "20230418000275" : "20230413000001",
    [TENANT_ENV.QZC]: isProd ? "20230828000223" : "20230814000001",
    [TENANT_ENV.JDJD]: isProd ? "20240305000009" : "20240305000001",
    [TENANT_ENV.JDZMD]: isProd ? "20240305000009" : "20240305000001",
};
